// extracted by mini-css-extract-plugin
module.exports = {"buttonholder":"Record_buttonholder__B--Dj","addbutton":"Record_addbutton__3ZjSP"};